import { createAction } from 'redux-act'

import HttpStatusCode from 'features/Styleboard/httpStatusCode'

import {
  FetchStyleboardResponse,
  Notification,
  NotificationType,
  StyleboardSuccessLocalState,
  MyStyleboardsReponse,
  Styleboard,
  FetchSimilarItemsResponse,
} from '../../types'

const fetchMoreDataStart = createAction('Styleboards - fetch more data start')
const fetchMoreDataSuccess = createAction<any>('Styleboards - fetch more data success')
const fetchMoreDataFail = createAction<any>('Styleboards - fetch more data fail')

const fetchStyleboardStart = createAction('Styleboards - fetch styleboard start')
const fetchStyleboardSuccess = createAction<FetchStyleboardResponse>(
  'Styleboards - fetch styleboard success',
)
const fetchStyleboardFail = createAction<any>('Styleboards - fetch styleboard fail')

const resetStyleboardState = createAction('Styleboards - reset styleboard state')

const fetchStyleboardsStart = createAction('Styleboards - fetch styleboards start')
const fetchStyleboardsSuccess = createAction<MyStyleboardsReponse>(
  'Styleboards - fetch styleboards success',
)
const fetchStyleboardsFail = createAction<any>('Styleboards - fetch styleboards fail')

const fetchSimilarItemsStart = createAction('Styleboards - fetch similar items start')
const fetchSimilarItemsSuccess = createAction<FetchSimilarItemsResponse | HttpStatusCode>(
  'Styleboards - fetch similar items success',
)
const fetchSimilarItemsFail = createAction<any>('Styleboards - fetch similar items fail')
const resetSimilarItemsState = createAction('Styleboards - reset similar items state')

const fetchFollowStyleboardsStart = createAction('Styleboards - fetch follow styleboards start')
const fetchFollowStyleboardsSuccess = createAction<MyStyleboardsReponse>(
  'Styleboards - fetch follow styleboards success',
)
const fetchFollowStyleboardsFail = createAction<any>('Styleboards - fetch follow styleboards fail')

const fetchPopularStyleboardsStart = createAction('Styleboards - fetch popular styleboards start')
const fetchPopularStyleboardsSuccess = createAction<Styleboard[]>(
  'Styleboards - fetch popular styleboards success',
)
const fetchPopularStyleboardsFail = createAction<any>(
  'Styleboards - fetch popular styleboards fail',
)

const fetchFollowStyleboardStart = createAction('My Styleboards - fetch follow styleboard start')
const fetchFollowStyleboardSuccess = createAction<any>(
  'My Styleboards - fetch follow styleboard success',
)
const fetchFollowStyleboardFail = createAction<any>('My Styleboards - fetch follow styleboard fail')

const followStyleboardStart = createAction('Styleboards - follow styleboard start')
const followStyleboardSuccess = createAction('Styleboards - follow styleboard success')
const followStyleboardFail = createAction<any>('Styleboards - follow styleboard fail')

const unfollowStyleboardStart = createAction('Styleboards - unfollow styleboard start')
const unfollowStyleboardSuccess = createAction('Styleboards - unfollow styleboard success')
const unfollowStyleboardFail = createAction<string>('Styleboards - unfollow styleboard fail')

const putStyleboardStart = createAction('Styleboards - save styleboard start')
const putStyleboardSuccess = createAction<StyleboardSuccessLocalState>(
  'Styleboards - save styleboard success',
)
const putStyleboardFailed = createAction<any>('Styleboards - save styleboard failed')

const putItemToStyleboardStart = createAction('Styleboards - add item to styleboard start')
const putItemToStyleboardSuccess = createAction<string>(
  'Styleboards - add item to styleboard success',
)
const putItemToStyleboardFailed = createAction<any>('Styleboards - add item to styleboard failed')

const deleteStyleboardStart = createAction('Styleboards - delete styleboard start')
const deleteStyleboardSuccess = createAction<string>('Styleboards - delete styleboard success')
const deleteStyleboardFailed = createAction<any>('Styleboards - delete styleboard failed')

const deleteItemFromStyleboardStart = createAction(
  'Styleboards - delete item from styleboard start',
)
const deleteItemFromStyleboardSuccess = createAction<string>(
  'Styleboards - delete item fromstyleboard success',
)
const deleteItemFromStyleboardFailed = createAction<any>(
  'Styleboards - delete item from styleboard failed',
)

const putAuthorStart = createAction('Styleboards - put user profile start')
const putAuthorSuccess = createAction<string>('Styleboards - put user profile  success')
const putAuthorFail = createAction<any>('Styleboards - put user profile  failed')

const addNotification = createAction<NotificationType>('Styleboards - add notification')
const removeNotification = createAction<Notification>('Styleboards - remove notification')
const removeNotificationByType = createAction<NotificationType>(
  'Styleboards - remove notification by type',
)
const addImageStart = createAction('Styleboards - add image start')
const addImageSuccess = createAction('Styleboards - add image  success')
const addImageFail = createAction<any>('Styleboards - add image  failed')

const resetImageUploadStatus = createAction('Styleboards - reset image upload status')

const individualImageChange = createAction<string>('Styleboards - individual image change')

const changeBackgroundImageSuccess = createAction<string>(
  'Styleboards - change background image success',
)

const fetchPublicStyleboardsStart = createAction('Styleboards - fetch public styleboards start')
const fetchPublicStyleboardsSuccess = createAction<MyStyleboardsReponse>(
  'Styleboards - fetch public styleboards success',
)
const fetchPublicStyleboardsFail = createAction<Error>(
  'Styleboards - fetch public styleboards fail',
)

export default {
  fetchMoreDataFail,
  fetchMoreDataStart,
  fetchMoreDataSuccess,
  fetchStyleboardStart,
  fetchStyleboardSuccess,
  fetchStyleboardFail,
  resetStyleboardState,
  fetchSimilarItemsStart,
  fetchSimilarItemsFail,
  fetchSimilarItemsSuccess,
  resetSimilarItemsState,
  fetchStyleboardsStart,
  fetchStyleboardsSuccess,
  fetchStyleboardsFail,
  fetchFollowStyleboardsStart,
  fetchFollowStyleboardsSuccess,
  fetchFollowStyleboardsFail,
  fetchPopularStyleboardsFail,
  fetchPopularStyleboardsSuccess,
  fetchPopularStyleboardsStart,
  followStyleboardStart,
  followStyleboardSuccess,
  followStyleboardFail,
  unfollowStyleboardStart,
  unfollowStyleboardSuccess,
  unfollowStyleboardFail,
  fetchFollowStyleboardStart,
  fetchFollowStyleboardSuccess,
  fetchFollowStyleboardFail,
  putStyleboardStart,
  putStyleboardSuccess,
  putStyleboardFailed,
  putItemToStyleboardStart,
  putItemToStyleboardSuccess,
  putItemToStyleboardFailed,
  deleteStyleboardStart,
  deleteStyleboardSuccess,
  deleteStyleboardFailed,
  putAuthorStart,
  putAuthorSuccess,
  putAuthorFail,
  addNotification,
  removeNotification,
  removeNotificationByType,
  addImageStart,
  addImageSuccess,
  addImageFail,
  resetImageUploadStatus,
  individualImageChange,
  deleteItemFromStyleboardStart,
  deleteItemFromStyleboardSuccess,
  deleteItemFromStyleboardFailed,
  changeBackgroundImageSuccess,
  fetchPublicStyleboardsStart,
  fetchPublicStyleboardsSuccess,
  fetchPublicStyleboardsFail,
}
